var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var CLASSES = {
    POPWRAP: 'ac-edit-popper-wrapper'
};
var WysiwygEditable = /** @class */ (function (_super) {
    __extends(WysiwygEditable, _super);
    function WysiwygEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WysiwygEditable.prototype.render = function () {
        var _this = this;
        var id = this.getEditorId();
        var $el = jQuery(this.getElement().querySelector('textarea'));
        $el.attr('id', id);
        this.getElement().addEventListener('click', function (e) { return e.preventDefault(); });
        setTimeout(function () {
            var settings = _this.getEditorSettings();
            var popper = _this.getElement().closest('.ac-edit-popper');
            var modal = _this.getElement().closest('.ac-modal.-bulkedit');
            // Inline Edit specific
            if (popper) {
                popper.classList.add('-full');
                _this.wrapPopper();
            }
            // Bulk Edit specific
            if (modal) {
                modal.classList.add('-wysiwyg');
                settings.tinymce.height = '300px';
            }
            wp.editor.initialize(id, settings);
        });
    };
    WysiwygEditable.prototype.wrapPopper = function () {
        var wrapper = document.createElement('div');
        var popper = this.getElement().closest('.ac-edit-popper');
        wrapper.classList.add(CLASSES.POPWRAP);
        document.body.append(wrapper);
        wrapper.appendChild(popper);
    };
    WysiwygEditable.prototype.removePopperwrap = function () {
        document.querySelectorAll("." + CLASSES.POPWRAP).forEach(function (el) { return el.remove(); });
    };
    WysiwygEditable.prototype.getEditorSettings = function () {
        var settings = Object.assign({}, wp.editor.getDefaultSettings());
        settings.tinymce.toolbar1 = 'formatselect,bold,italic,bullist,numlist,blockquote,alignleft,alignright,aligncenter,link,unlink,wp_add_media,wp_more,fullscreen,wp_adv';
        settings.tinymce.toolbar2 = 'strikethrough,hr,forecolor,pastetext,removeformat,charmap,undo,redo';
        settings.tinymce.width = '100%';
        settings.quicktags = true;
        settings.mediaButtons = true;
        return settings;
    };
    WysiwygEditable.prototype.close = function () {
        this.id = null;
        this.removePopperwrap();
        return _super.prototype.close.call(this);
    };
    WysiwygEditable.prototype.getEditorId = function () {
        if (!this.id) {
            this.id = 'acp_' + Math.floor(Math.random() * 10000) + '_' + Math.floor(Math.random() * 10000) + '_' + Math.floor(Math.random() * 10000);
        }
        return this.id;
    };
    WysiwygEditable.prototype.valueToInput = function (value) {
        var textarea = this.getElement().querySelector('textarea');
        if (!value || !textarea) {
            return;
        }
        textarea.value = value;
    };
    WysiwygEditable.prototype.getValue = function () {
        var id = this.getEditorId();
        return wp.editor.getContent(id);
    };
    WysiwygEditable.prototype.preventStopPropagation = function (e, type) {
        return true;
    };
    WysiwygEditable.prototype.getTemplate = function () {
        return "<textarea></textarea>";
    };
    WysiwygEditable.prototype._setDefaults = function () {
        this._defaults.type = 'wysiwyg';
    };
    return WysiwygEditable;
}(AbstractEditable));
export default WysiwygEditable;
